import type { TimeEntry } from "./models.js";

export function parseIsoDate(value: string): Date {
  return new Date(value);
}

export function startOfLocalDay(date: Date): Date {
  const result = new Date(date);
  result.setHours(0, 0, 0, 0);
  return result;
}

export function nextLocalDay(date: Date): Date {
  const result = startOfLocalDay(date);
  result.setDate(result.getDate() + 1);
  return result;
}

export function safeEndTime(startTime: Date, endTime: Date): Date {
  return endTime > startTime ? endTime : new Date(startTime.getTime() + 1000);
}

export function toLocalDayKey(input: Date | string): string {
  const date = typeof input === "string" ? parseIsoDate(input) : input;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function fromLocalDayKey(dayKey: string): Date {
  return new Date(`${dayKey}T00:00:00`);
}

export function entrySpanSeconds(entry: Pick<TimeEntry, "startTime" | "endTime">): number {
  const startTime = parseIsoDate(entry.startTime);
  const endTime = safeEndTime(startTime, parseIsoDate(entry.endTime));
  return Math.max(0, Math.round((endTime.getTime() - startTime.getTime()) / 1000));
}

export function activeSessionElapsedSeconds(
  startTime: string,
  now = new Date(),
  pausedDurationSeconds = 0,
  pausedAt: string | null = null,
): number {
  const startedAt = parseIsoDate(startTime);
  const effectiveNow = pausedAt ? parseIsoDate(pausedAt) : now;
  return Math.max(
    0,
    Math.round((effectiveNow.getTime() - startedAt.getTime()) / 1000) - pausedDurationSeconds,
  );
}

export function timeEntryCrossesMidnight(entry: Pick<TimeEntry, "startTime" | "endTime">): boolean {
  return toLocalDayKey(entry.startTime) !== toLocalDayKey(entry.endTime);
}
